module.exports = __webpack_public_path__ + "static/assets/253b46780be9ceeb16dd390fa34f1822.png";